import { forwardRef } from 'react';
import type { SVGProps } from 'react';

export interface GoogleMarkProps extends Omit<SVGProps<SVGSVGElement>, 'fill'> {
  /** Hauteur (px de reference) du logo. Carre. Defaut 18. */
  height?: number;
}

/**
 * Le « G » de Google, SVG inline.
 *
 * POURQUOI IL A LE DROIT DE PORTER DES HEX EN DUR, alors que la doctrine
 * l'interdit partout (`AGENTS.md`, regle d'or 2) : ce ne sont pas des couleurs
 * de MyTaki, ce sont celles d'une MARQUE, et Google exige son logo tel quel sur
 * un bouton « Se connecter avec Google ». Un logo ne se retheme pas, pas plus
 * que le wordmark Taki juste a cote (`TakiWordmark.tsx`) : ces deux fichiers
 * sont les seuls de ce genre, et c'est ce qui les rend reperables.
 *
 * Il ne suit donc PAS `currentColor` : il garde ses quatre couleurs sur fond
 * clair comme sur fond sombre, ce que la charte de Google demande.
 */
export const GoogleMark = forwardRef<SVGSVGElement, GoogleMarkProps>(function GoogleMark(
  { height = 18, className, ...props },
  ref,
) {
  const taille = `${height / 16}rem`;
  return (
    <svg
      ref={ref}
      height={taille}
      width={taille}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...props}
    >
      <path
        fill="#4285F4"
        d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"
      />
      <path
        fill="#34A853"
        d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"
      />
      <path
        fill="#FBBC05"
        d="M11.69 28.18c-.44-1.32-.69-2.73-.69-4.18s.25-2.86.69-4.18v-5.7H4.34A21.99 21.99 0 0 0 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z"
      />
      <path
        fill="#EA4335"
        d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z"
      />
    </svg>
  );
});
